import { CrudStoreItemOnboarding } from 'legacy/lut/classes/models/onboarding/CrudStoreItemOnboarding'
import { IPartnerShipLA } from 'legacy/lut/components/widgets/public/onboarding/requestsInfo/requestDetail/actionView/dataCollector/FormComponents/partnerShip/hooks/usePartnerShipLA'
import { IPartnerShipNA } from 'legacy/lut/components/widgets/public/onboarding/requestsInfo/requestDetail/actionView/dataCollector/FormComponents/partnerShip/types'
import { EFormSource } from 'legacy/lut/components/widgets/public/onboarding/requestsInfo/requestDetail/actionView/dataCollector/FormSelector'

import { Logic, Operator } from 'core-components/types'
import { getTokens } from 'core/classes/helpers/StorageHelper'
import WebSocketStore from 'core/classes/services/WebSocketStore'
import { CrudStore } from 'core/types/crudStore'
import { IRequestorLA } from 'onboarding/classes/models/requestorLA'

class OnboardingPartnershipApi {
  public getCrudLA() {
    return CrudStore.get(CrudStoreItemOnboarding.PartnerShipLA)
  }

  public getLAByRequestId(requestId: number, force: boolean): Promise<IPartnerShipLA | null> {
    return this.getCrudLA().getById({ id: requestId, force, keyField: 'RequestId' })
  }

  public createLA(data: Partial<IRequestorLA>[]): Promise<IPartnerShipLA[]> {
    return this.getCrudLA().create(EFormSource.PartnershipDetailsLA, data)
  }

  public updateLA(data: Partial<IRequestorLA>[]): Promise<IPartnerShipLA[]> {
    return this.getCrudLA().update(EFormSource.PartnershipDetailsLA, data)
  }

  public saveNA = async (
    payload: IPartnerShipNA,
    appOwnerId: string
  ): Promise<{
    data: IPartnerShipNA | null
    error?: string
  }> => {
    const wsClient = WebSocketStore.get('onboarding')
    try {
      const [token] = getTokens(appOwnerId)
      const response = await wsClient.call<{ item: IPartnerShipNA }>({
        service: 'partnership',
        action: 'saveNA',
        payload,
        token: token || undefined,
        withoutTokenRefresh: true,
        isAuth: true,
      })

      return {
        data: response.data.item,
      }
    } catch (e: any) {
      let errorMessage = 'Failed to save'
      if (typeof e === 'string') {
        errorMessage = e
      } else if (e.message) {
        errorMessage = e.message
      }
      return {
        data: null,
        error: errorMessage,
      }
    }
  }

  public getNAByRequestId = async (
    requestId: number,
    appOwnerId: string
  ): Promise<{
    data: IPartnerShipNA | null
    error?: string
  }> => {
    const wsClient = WebSocketStore.get('onboarding')
    try {
      const [token] = getTokens(appOwnerId)
      const response = await wsClient.call<{ item: IPartnerShipNA | null }>({
        service: 'partnership',
        action: 'fetchByRequestId',
        payload: { requestId },
        token: token || undefined,
        withoutTokenRefresh: true,
        isAuth: true,
      })

      return {
        data: response.data.item,
      }
    } catch (e: any) {
      let errorMessage = 'Failed to fetch by request id'
      if (typeof e === 'string') {
        errorMessage = e
      } else if (e.message) {
        errorMessage = e.message
      }
      return {
        data: null,
        error: errorMessage,
      }
    }
  }
}

export const onboardingPartnershipApi = new OnboardingPartnershipApi()
